





















































































































































































































































































































































































































import { createOperationLogApi } from "@/api/store";
import { getSelectClassList } from "@/api/globalSearch";
import { eduClassListApi, eduClassListInter } from "@/api/statistics";
import { dateFormat } from "@/utils/timeFormat";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import json2csv from "json2csv";
import { roundNumbers } from "@/utils/roundNumbers";
@Component({
  components: {},
})
export default class extends Vue {
  @Prop() data!: any;
  activeName = "one_to_many";
  oneClassListData: any = [];
  manyClassListData: any = [];
  searchInfo: any = {
    one_class_status: -1,
    many_class_status: -1,
  };
  currentSortOption: any = {
    order: "descending",
    prop: "consume_amount",
  };
  oneTableData: any = [];
  manyTableData: any = [];
  paginationData: any = [];
  exporting: boolean = false;
  @Watch("data", { immediate: false, deep: true })
  onChangeValue(v: any) {
    this.getList();
  }
  created() {
    this.getList();
    this.handleOneChangeClassList("");
    this.handleManyChangeClassList("");
  }
  handleTabChange() {
    this.getList();
  }
  handleOneChangeClassList(v: any) {
    getSelectClassList({
      page: 1,
      page_size: 100,
      course_type: 2,
      name: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.oneClassListData = res.data.list;
      }
    });
  }
  handleManyChangeClassList(v: any) {
    getSelectClassList({
      page: 1,
      page_size: 100,
      course_type: 1,
      name: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.manyClassListData = res.data.list;
      }
    });
  }
  getList() {
    const params: eduClassListInter = {
      start_date: this.data[0],
      end_date: this.data[1],
      course_type: this.activeName === "one_to_one" ? 2 : 1,
    };
    if (this.activeName === "one_to_one") {
      if (this.searchInfo.one_class_id) {
        params.class_id = this.searchInfo.one_class_id;
      }
      if (this.searchInfo.one_class_status > 0) {
        params.status = this.searchInfo.one_class_status;
      }
    }
    if (this.activeName === "one_to_many") {
      if (this.searchInfo.many_class_id) {
        params.class_id = this.searchInfo.many_class_id;
      }
      if (this.searchInfo.many_class_status > 0) {
        params.status = this.searchInfo.many_class_status;
      }
    }
    eduClassListApi(params).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.map((it: any) => {
          it.attendance_rate = roundNumbers(it.attendance_rate);
          it.real_consume_num = roundNumbers(it.real_consume_num);
          it.consume_amount = roundNumbers(it.consume_amount);
        });
        if (this.activeName === "one_to_one") {
          this.oneTableData = res.data.list;
        } else {
          this.manyTableData = res.data.list;
        }
        this.paginationData = res.data.list;
        this.handleSortChange({
          order: "descending",
          prop: "consume_amount",
        });
      }
    });
  }
  handleSortChange(val: any) {
    this.currentSortOption = {
      order: val.order,
      prop: val.prop,
    };
    if (this.activeName === "one_to_one") {
      this.oneTableData = this.sortList(this.oneTableData);
      let n = 0;
      this.oneTableData.map((it: any, ind: any) => {
        n += 1;
        it.num = n;
      });
    } else {
      this.manyTableData = this.sortList(this.manyTableData);
      let n = 0;
      this.manyTableData.map((it: any, ind: any) => {
        n += 1;
        it.num = n;
      });
    }
  }
  sortList(val: any[]) {
    const copy = [...val];
    copy.sort((a: any, b: any) => {
      return (
        Number(b[this.currentSortOption.prop]) -
        Number(a[this.currentSortOption.prop])
      );
    });
    copy.map((it: any, ind: any) => {
      it.ind = ind + 1;
    });
    if (this.currentSortOption.order === "ascending") {
      copy.reverse();
    }
    return copy;
  }
  handleSearch() {
    this.getList();
  }
  // 导出
  handleExport() {
    if (this.exporting) {
      return false;
    }
    createOperationLogApi({
      code: 10503,
      detail: "导出教务数据明细",
    });
    const dateArr =
      this.activeName === "one_to_one"
        ? JSON.parse(JSON.stringify(this.oneTableData))
        : JSON.parse(JSON.stringify(this.manyTableData));
    dateArr.map((it: any) => {
      it.class.completion_status =
        it.class.completion_status === 1 ? "未结业" : "已结业";
    });
    this.exporting = true;
    const date: any = new Date().getTime();
    const dateTime = dateFormat("YYYYmmddHHMMSS", date);
    const endThree = String(date).slice(-3, date.length);
    try {
      let result = "";
      if (this.activeName === "one_to_one") {
        result = json2csv.parse(
          [
            {
              "class.name": " 班级名称",
              "class.completion_status": "班级状态",
              otm_sufficient_class_rate: "在读学员",
              attendance_rate: "出勤率 (%)",
              roll_call_attend_student_num: "点名实到学员",
              // roll_call_absent_student_num: "点名未到学员",
              roll_call_should_attend_student_num: "点名应到学员",
              roll_call_make_up_student_num: "点名补课学员",
              // roll_call_experience_student_num: "点名体验学员数据",
              roll_call_lesson_num: "点名课次",
              real_consume_num: "耗课数",
              consume_amount: " 课消金额 (元)",
            },
            ...dateArr,
          ],
          {
            fields: [
              "class.name",
              "class.completion_status",
              "otm_sufficient_class_rate",
              "attendance_rate",
              "roll_call_attend_student_num",
              // "roll_call_absent_student_num",
              "roll_call_should_attend_student_num",
              "roll_call_make_up_student_num",
              // "roll_call_experience_student_num",
              "roll_call_lesson_num",
              "real_consume_num",
              "consume_amount",
            ],
            header: false,
          }
        );
      } else {
        // 1vN导出
        result = json2csv.parse(
          [
            {
              "class.name": " 班级名称",
              "class.completion_status": "班级状态",
              otm_sufficient_class_rate: "在读学员",
              class_preset_student_num: "班级容量",
              attendance_rate: "出勤率 (%)",
              roll_call_attend_student_num: "点名实到学员",
              // roll_call_absent_student_num: "点名未到学员",
              roll_call_should_attend_student_num: "点名应到学员",
              roll_call_make_up_student_num: "点名补课学员",
              // roll_call_experience_student_num: "点名体验学员数据",
              roll_call_lesson_num: "点名课次",
              real_consume_num: "耗课数",
              consume_amount: " 课消金额 (元)",
            },
            ...dateArr,
          ],
          {
            fields: [
              "class.name",
              "class.completion_status",
              "otm_sufficient_class_rate",
              "class_preset_student_num",
              "attendance_rate",
              "roll_call_attend_student_num",
              // "roll_call_absent_student_num",
              "roll_call_should_attend_student_num",
              "roll_call_make_up_student_num",
              // "roll_call_experience_student_num",
              "roll_call_lesson_num",
              "real_consume_num",
              "consume_amount",
            ],
            header: false,
          }
        );
      }
      // 非IE浏览器
      const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
      // 创建a标签下载
      const link = document.createElement("a");
      link.href = encodeURI(csvContent);
      link.download = "教务数据" + dateTime + endThree;
      (".csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // 5秒导出间隔
      setTimeout(() => {
        this.exporting = false;
      }, 5000);
    } catch (err: any) {
      this.$message({
        type: "error",
        message: err.toString(),
      });
    }
  }
}
